import { TreeNode } from 'rc-tree';
import TreePure from './Tree';
import DirectoryTree from './DirectoryTree';
var Tree = TreePure;
Tree.DirectoryTree = DirectoryTree;
Tree.TreeNode = TreeNode;
export default Tree;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/tree/index.js
// module id = 1088
// module chunks = 1